export const filterDataByTimeRange = (data, range) => {
  if (!data || data.length === 0) return data;
  if (range === 'All') return data;

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.datetime || a.date);
    const dateB = new Date(b.datetime || b.date);
    return dateA - dateB;
  });

  let barsToShow;

  switch (range) {
    case '1D':
      barsToShow = 390;
      break;
    case '5D':
      barsToShow = 390 * 5;
      break;
    case '1M':
      barsToShow = 390 * 20;
      break;
    case '3M':
      barsToShow = 390 * 60;
      break;
    case 'YTD':
      const lastDate = new Date(sortedData[sortedData.length - 1].datetime || sortedData[sortedData.length - 1].date);
      const startOfYear = new Date(lastDate.getFullYear(), 0, 1, 0, 0, 0, 0);
      
      console.log(` Filter range: YTD`);
      console.log(` Last date: ${lastDate}`);
      console.log(` Start of year: ${startOfYear}`);
      
      const ytdFiltered = sortedData.filter(item => {
        const itemDate = new Date(item.datetime || item.date);
        return itemDate >= startOfYear;
      });
      
      console.log(` Filtered ${ytdFiltered.length} records from ${sortedData.length} total`);
      return ytdFiltered;
      
    case '1Y':
      barsToShow = 390 * 252;
      break;
    case '5Y':
      barsToShow = 390 * 1260;
      break;
    default:
      return sortedData;
  }

  const startIndex = Math.max(0, sortedData.length - barsToShow);
  const filtered = sortedData.slice(startIndex);

  console.log(` Filter range: ${range}`);
  console.log(` Requested bars: ${barsToShow}`);
  console.log(` Total data: ${sortedData.length}`);
  console.log(` Filtered ${filtered.length} records (from index ${startIndex})`);
  
  if (filtered.length > 0) {
    console.log(` First: ${filtered[0].datetime || filtered[0].date}`);
    console.log(` Last: ${filtered[filtered.length - 1].datetime || filtered[filtered.length - 1].date}`);
  }

  return filtered;
};

export const filterDataByCustomRange = (data, startDateStr, endDateStr) => {
  if (!data || data.length === 0) return data;
  if (!startDateStr || !endDateStr) return data;

  console.log(' Filtering custom range:', startDateStr, 'to', endDateStr);
  console.log(' Total data before filter:', data.length);

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.datetime || a.date);
    const dateB = new Date(b.datetime || b.date);
    return dateA - dateB;
  });

  //  ตั้งค่าเวลาเป็น 00:00:00 สำหรับ startDate
  const startDate = new Date(startDateStr);
  startDate.setHours(0, 0, 0, 0);

  //  ตั้งค่าเวลาเป็น 23:59:59 สำหรับ endDate
  const endDate = new Date(endDateStr);
  endDate.setHours(23, 59, 59, 999);

  console.log('🔍 Start date:', startDate);
  console.log('🔍 End date:', endDate);

  const filtered = sortedData.filter(item => {
    const itemDate = new Date(item.datetime || item.date);
    return itemDate >= startDate && itemDate <= endDate;
  });

  console.log(' Filtered data count:', filtered.length);
  
  if (filtered.length > 0) {
    console.log(' First item:', filtered[0].datetime || filtered[0].date);
    console.log(' Last item:', filtered[filtered.length - 1].datetime || filtered[filtered.length - 1].date);
  }

  return filtered;
};